import { Target } from '@nirvana/shared/dtos/types/dashboards/common';
import { ReportingPeriod } from '@nirvana/shared/dtos/types/shared/time';
import { DisplayMode } from '../common/types';

export interface GetInformationRequest {
  payload: GetWidgetDataRequest;
}

export interface GetWidgetDataRequest {
  reportingPeriod: ReportingPeriod;
  dashboardId: string;
  widgetId: string;
  locale: string;
  timezone: string;
  targetIds: Array<string>;
}

export interface ValueWithDelta {
  currentValue: number;
  delta: number;
}

export type BackendResponseWithMeta<T> = T & DashboardMetadata;

export const DASHBOARD_METADATA_KEY = 'meta';

export interface DashboardMetadata {
  [DASHBOARD_METADATA_KEY]: {
    reportingPeriod: ReportingPeriod;
    targets: Array<Target>;
    canDrillDown: boolean;
    displayMode: DisplayMode;
  };
}
